<template>
  <div
    :class="{
      'has-error': hasError,
      'has-success': isPassed,
    }"
    class="control has-icons has-icons-right"
  >
    <input
      v-if="format"
      v-on:input="$emit('input', $event.target.value)"
      v-mask="format"
      :value="value"
      :class="{ 'has-value': value }"
      :type="type"
      class="input"
      :placeholder="placeholder"
    />
    <input
      v-else
      v-on:input="$emit('input', $event.target.value)"
      :value="value"
      :class="{ 'has-value': value }"
      :type="type"
      class="input"
      :placeholder="placeholder"
    />
    <span
      v-if="hasIcon"
      :class="{
        'has-text-errorlight': hasError,
        'has-text-successlight': isPassed,
      }"
      class="icon is-right"
    >
      <base-icon v-if="hasError" name="painel/close-circle-icon" />
      <base-icon v-if="isPassed" name="painel/check-circle-icon" />
    </span>
    <label class="label">
      <slot></slot>
    </label>
    <i v-if="hasBar" class="bar"></i>
    <p v-if="hasError" class="help is-error">
      {{ firstError }}
    </p>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },

  props: {
    value: {
      required: true,
    },
    type: {
      default: 'text',
    },
    hasError: {
      type: Boolean,
    },
    hasIcon: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    firstError: {
      type: String,
    },
    isPassed: {
      type: Boolean,
    },
    format: {
      default: '',
    },
    hasBar: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
